import React, { useState, useEffect } from 'react';
import Sidebar from '../Shared/Sidebar';
import Icon from '../Shared/Icons';
import { useAuth } from '../../context/AuthContext';
import { MEMBER_TYPES, PROGRAMS } from '../../config/programs';
import { findDuplicateGroups, mergeMembers } from '../../utils/memberDedupe';
import { resolveAuthorName } from '../../utils/programData';
import { fmtDate } from '../../utils/weekUtils';
import { S, T } from './ui';

// ── WANACHAMA WANAORUDIA ────────────────────────────────────────────────
// Wanachama wenye jina na aina moja wanaonekana hapa kama kikundi.
// Admin anachagua rekodi ya KUBAKI NAYO — ripoti zote za rekodi
// nyingine zinahamia huko badala ya kupotea, kisha nakala zinafutwa.

export default function DuplicateMembers() {
  const { currentUser } = useAuth();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [picked, setPicked] = useState({}); // groupIndex -> memberId ya kubaki
  const [busy, setBusy] = useState(null);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try {
      const gs = await findDuplicateGroups();
      setGroups(gs);
      const p = {};
      gs.forEach((g, i) => { p[i] = g[0].id; }); // chaguo-msingi: aliyesajiliwa kwanza
      setPicked(p);
    } catch (e) { console.error(e); setErr('Imeshindikana kupakia data.'); }
    setLoading(false);
  }

  async function doMerge(groupIndex) {
    const group = groups[groupIndex];
    const keepId = picked[groupIndex];
    const mergeIds = group.map(m => m.id).filter(id => id !== keepId);
    if (!mergeIds.length) return;

    if (!window.confirm(
      `Unganisha rekodi ${mergeIds.length} kuwa moja? Ripoti zote zitahamia kwenye rekodi uliyoichagua. Hatua hii haiwezi kutenduliwa.`
    )) return;

    setBusy(groupIndex); setErr(''); setMsg('');
    try {
      const name = await resolveAuthorName(currentUser);
      const out = await mergeMembers({ keepId, mergeIds, author: { name } });
      setMsg(
        `Zimeunganishwa: ripoti ${out.movedIndividual} zimehamishwa, ${out.movedAsContribution} zimewekwa kama nyongeza, ` +
        `mahudhurio ${out.movedAttendance} yamehamishwa, rekodi ${out.removed} zimeondolewa.`
      );
      await load();
      setTimeout(() => setMsg(''), 6000);
    } catch (e) {
      console.error(e);
      setErr('Imeshindikana kuunganisha. Jaribu tena.');
    }
    setBusy(null);
  }

  function programNames(ids) {
    return (ids || []).map(id => PROGRAMS.find(p => p.id === id)?.short).filter(Boolean).join(', ') || '—';
  }

  return (
    <div style={S.layout}>
      <Sidebar />
      <div style={S.main}>

        <h1 style={S.h1}>Wanachama Wanaorudia</h1>
        <p style={{ ...S.sub, marginTop: '6px', marginBottom: '18px' }}>
          Hawa ni wanachama wenye jina na aina moja — huenda ni mtu mmoja
          aliyesajiliwa zaidi ya mara moja. Chagua rekodi ya kubaki nayo;
          ripoti za nyingine zitahamia huko kabla ya kufutwa.
        </p>

        {msg && <div style={S.ok}>{msg}</div>}
        {err && <div style={S.err}>{err}</div>}

        {loading ? (
          <div style={{ ...S.card, ...S.empty }}>Inapakia...</div>
        ) : groups.length === 0 ? (
          <div style={{ ...S.card, ...S.empty }}>
            <Icon name="check" size={20} color="#059669" />
            <div style={{ marginTop: '9px' }}>Hakuna marudio yaliyogunduliwa. Data iko safi.</div>
          </div>
        ) : groups.map((group, gi) => (
          <div key={gi} style={S.card}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '9px', marginBottom: '14px' }}>
              <div style={{
                width: '30px', height: '30px', borderRadius: '9px', background: '#FEF3C7',
                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
              }}>
                <Icon name="info" size={14} color="#D97706" />
              </div>
              <div>
                <div style={{ fontSize: '14.5px', fontWeight: 800, color: T.ink }}>{group[0].fullName}</div>
                <div style={{ fontSize: '11.5px', color: T.muted, marginTop: '2px' }}>
                  {MEMBER_TYPES[group[0].type]?.label} · rekodi {group.length}
                </div>
              </div>
            </div>

            {group.map(m => (
              <label
                key={m.id}
                style={{
                  display: 'flex', gap: '11px', alignItems: 'flex-start', cursor: 'pointer',
                  padding: '11px 13px', borderRadius: '11px', marginBottom: '8px',
                  border: `1px solid ${picked[gi] === m.id ? '#059669' : T.line}`,
                  background: picked[gi] === m.id ? '#ECFDF5' : '#FCFBF8',
                }}
              >
                <input
                  type="radio"
                  name={`group-${gi}`}
                  checked={picked[gi] === m.id}
                  onChange={() => setPicked(p => ({ ...p, [gi]: m.id }))}
                  style={{ marginTop: '3px', width: '16px', height: '16px', flexShrink: 0 }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: T.ink }}>
                    {m.school || m.centre || m.area || '—'}
                    {m.clubName ? ` · ${m.clubName}` : ' · hana club'}
                  </div>
                  <div style={{ fontSize: '11px', color: T.muted, marginTop: '4px', lineHeight: 1.6 }}>
                    Programu: {programNames(m.programIds)} · Ripoti {m.reportCount}
                    <br />
                    Alisajiliwa {fmtDate(m.createdAt)}
                    {m.createdByName ? ` na ${m.createdByName}` : ''}
                  </div>
                </div>
                {picked[gi] === m.id && (
                  <span style={{ ...S.pill, color: '#059669', background: '#D1FAE5', whiteSpace: 'nowrap' }}>
                    Itabaki
                  </span>
                )}
              </label>
            ))}

            <button
              style={{ ...S.btn, width: '100%', marginTop: '9px', opacity: busy === gi ? 0.6 : 1 }}
              disabled={busy === gi}
              onClick={() => doMerge(gi)}
            >
              {busy === gi ? 'Inaunganisha…' : `Unganisha kuwa rekodi 1 (futa ${group.length - 1})`}
            </button>
          </div>
        ))}

      </div>
    </div>
  );
}
